export default __webpack_public_path__ + "static/media/remove.a4e6e0d4.svg";